import {signal} from '@preact/signals'

export const unsavedChanges = signal(false)
export const assetDashboardAddAction = signal(false)
export const queryParamsForFundNzc = signal({})